<app-management-content-main-header></app-management-content-main-header>
<div class="row"></div>
<div class="container custome-container mt-10">
    <div class="row">
        <!-- <div class="col-lg-3"> -->
        <!-- <app-lists-widget10 cssClass="gutter-b card-stretch"></app-lists-widget10> -->
        <!-- <app-sidebar cssClass="gutter-b card-stretch"></app-sidebar> -->
        <!-- </div> -->
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch ps-10 pe-10 pt-10 pb-10">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <div class="organization_header">
                                <!-- <h3>Organization</h3> -->

                                <div class="widget_sec">
                                    <ul>
                                        <li>
                                            <a [routerLink]="['/management/organization']">{{ 'SELECT_ORG_PAGE.TITLES.ORGANIZATION' | transloco }}</a>
                                        </li>
                                        <li>
                                            <a (click)="navigateToInstance()">{{ 'SELECT_ORG_PAGE.TITLES.INSTANCE' | transloco }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <app-instance-card></app-instance-card>
                </div>
            </div>
        </div>
    </div>
</div>
